import { animateScroll, Events } from 'react-scroll';

const isScrollRequireTempId = (containerSelector, containerElement) =>
  (containerSelector && containerElement && containerSelector.startsWith('.'));

const scrollWithTempId = (element, options, callback) => {
  const containerId = 'TEMP_ID_FOR_SCROLL';
  element.setAttribute('id', containerId);
  callback({ ...options, containerId });
  element.removeAttribute('id');
};

const smoothScroll = (containerSelector, containerElement, scrollOffset, options, to, target) => {
  const scroll = (opts) => animateScroll.animateTopScroll(scrollOffset, opts, to, target);

  !isScrollRequireTempId(containerSelector, containerElement)
    ? scroll(options)
    : scrollWithTempId(containerElement, options, scroll);
};

export default function scrollTo(to, props) {
  const target = this.get(to);

  if (!target) {
    console.warn('target Element not found');
    return;
  }

  const options = {
    ...props,
    absolute: false
  };

  if (Events.registered.begin) {
    Events.registered.begin(to, target);
  }

  const containerSelector = options.containerSelector;
  const containerElement = containerSelector ? document.querySelector(containerSelector) : null;

  let scrollOffset;

  if (containerSelector && containerElement) {
    options.absolute = true;
    if (containerElement !== target.offsetParent) {
      if (!containerElement.contains(target)) {
        throw new Error(`Container with selector ${containerSelector} is not a parent of target ${to}`);
      }
    }

    scrollOffset = target.offsetTop;
  } else {
    const coordinates = target.getBoundingClientRect();
    scrollOffset = coordinates.top;
  }

  scrollOffset += (options.offset || 0);

  if (!options.smooth) {
    if (containerSelector && containerElement) {
      containerElement.scrollTop = scrollOffset;
    } else {
      const bodyRect = document.body.getBoundingClientRect();
      window.scrollTo(0, scrollOffset - bodyRect.top);
    }

    if (Events.registered.end) {
      Events.registered.end(to, target);
    }

    return;
  }

  smoothScroll(containerSelector, containerElement, scrollOffset, options, to, target);
}

